// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2dd1w","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3VwJ-","obliqueLine":"membershipbadge_obliqueLine__15U2j"};